export default __webpack_public_path__ + "static/media/required-disabled-ico.61931fc2.svg";